import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Calendar, User } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";
import { POSTS } from "../data/site";

export default function BlogPage() {
  return (
    <div data-testid="blog-page">
      <Seo title="Blog — IDEAL ENTERPRISES" description="Insights on CGD, PNG networks, pipeline construction, HDD, and gas infrastructure safety." />
      <PageHeader
        overline="INSIGHTS"
        title="Field notes on CGD, pipelines, HDD, and safety."
        subtitle="Working notes from our engineering team — written for operators, EPC contractors, and curious decision-makers."
        bgImage="https://images.pexels.com/photos/36825977/pexels-photo-36825977.jpeg"
      />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {POSTS.map((p, i) => (
            <motion.article
              key={p.slug}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="bg-white border border-slate-200 group"
              data-testid={`blog-card-${p.slug}`}
            >
              <Link to={`/blog/${p.slug}`}>
                <div className="aspect-[5/3] overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <p className="overline">{p.category}</p>
                  <h3 className="font-heading font-bold text-xl text-brand-blue mt-3 group-hover:text-brand-orange transition-colors leading-snug">
                    {p.title}
                  </h3>
                  <p className="text-sm text-slate-600 mt-3 leading-relaxed">{p.excerpt}</p>
                  <div className="mt-5 pt-4 border-t border-slate-200 flex items-center justify-between text-xs text-slate-500 font-mono-tech">
                    <span className="inline-flex items-center gap-1.5"><User size={12} />{p.author}</span>
                    <span className="inline-flex items-center gap-1.5"><Calendar size={12} />{p.date}</span>
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </section>
    </div>
  );
}
